import { isApiError } from '@/lib/errors';

/**
 * True when an API error means the user has no custodial wallet yet and must
 * complete custodial onboarding (in-app social login → server-side provisioning)
 * before speed trading can continue.
 */
export function isCustodialWalletMissingError(error: unknown): boolean {
    return isApiError(error) && error.body?.code === 'custodialWalletMissing';
}
